export const PresentInEUCountries = {
    TRUE: 'true',
    FALSE: 'false',
};